import posthog from 'posthog-js';
import qs from 'query-string';

import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import i18n from '@/lib/i18n/i18n';

import useAuth from './useAuth';

export default function useClickUpForm(
  formUrls: Record<string, string>,
  extraParams?: Record<string, Maybe<string>>,
) {
  const { broker } = useAuth();
  const { email, analysis } = useEmail();

  const formUrl = formUrls?.[i18n.language ?? 'nl'] ?? formUrls?.['nl'] ?? '';

  const phSessionUrl = posthog.get_session_replay_url();

  const params = qs.stringify(
    {
      ...extraParams,
      PostHog: phSessionUrl,
      Language: i18n.language,
      MessageId: email?.messageId,
      EmailId: analysis.email?.id,
      ConversationId: analysis.email?.conversation_id,
      'Broker Plan': broker?.plan,
      'Broker Email': broker?.email,
      'Distribution Id': broker?.distribution_id,
      Distribution: broker?.distribution_name,
    },
    { sort: false },
  );

  let url = `${formUrl}?${params}`;

  if (url.length > 2000) {
    url = url.substring(0, 1997);
    url += '_CUT';
  }

  return url;
}
